import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { CanalVenda } from '../../../../home/common/canais-venda/domain';

@Component({
  selector: 'sgt-novo-canal-venda-multiselect',
  templateUrl: './novo-canal-venda-multiselect.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NovoCanalVendaMultiselectComponent),
      multi: true
    }
  ]
})
export class NovoCanalVendaMultiselectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit {
  @Input() idsCanaisVendas: number[];
  @Output() idsCanaisVendasChange = new EventEmitter<number[]>();

  settings: IMultiSelectSettings = {
    placeholder: 'Selecione os canais de venda',
    plural: 'Canais de Venda',
    singular: 'Canal de Venda',
    searchEmptyResultMessage: 'Nenhum canal de venda encontrado',
    showFooter: false
  };

  options: IOption[] = [];

  constructor() {
    super();
  }

  ngOnInit() {
    this.create();
  }

  private create() {
    this.options = [];
    const selects: IOption[] = [];

    CanalVenda.getAll().forEach((canalVenda) => {
      selects.push({
        id: canalVenda.id,
        label: canalVenda.nome
      });
    });

    this.options = selects;
  }

  onSearch() {
    this.idsCanaisVendasChange.emit(this.value);
  }

  onChangeCanaisVendas() {
    this.emitChange(this.idsCanaisVendas);
    this.markAsTouched();
  }

  protected updateValue(newValue: number[] | null): void {
    this.idsCanaisVendas = newValue;
  }
}
